import React from 'react';
import './SelectModal.css';

const SelectModal = ({
  isOpen,
  onClose,
  title,
  items,
  selectedItemId,
  onItemSelect,
  loading,
  renderItem,
  emptyMessage = "No items available."
}) => {
  if (!isOpen) return null;

  return (
    <div className="select-modal-overlay" onClick={onClose}>
      <div
        className="select-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>{title}</h3>
        {loading ? (
          <p>Loading...</p>
        ) : items.length > 0 ? (
          <ul className="select-modal-list">
            {items.map((item) => (
              <li
                key={item.id}
                onClick={() => onItemSelect(item.id)}
                className={`select-modal-item ${
                  selectedItemId === item.id ? "selected" : ""
                }`}
              >
                {renderItem ? renderItem(item) : (
                  <>
                    <strong>{item.name}</strong>
                    {item.description && <p>{item.description}</p>}
                  </>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p>{emptyMessage}</p>
        )}
      </div>
    </div>
  );
};

export default SelectModal;
